// Libellés qui dépendent de l'équipe. Dans Playbook BCL, « joueuse » était
// écrit en dur ~1 000 fois : impossible d'ouvrir l'app à une équipe masculine.
// Ici le genre est une propriété de l'équipe, et le texte en découle.
// Pas d'écriture inclusive (décision D-008) : mixte → masculin générique.

export type TeamGender = 'F' | 'M' | 'X';

export function playerNoun(gender: TeamGender, count = 1): string {
  const plural = Math.abs(count) > 1;
  if (gender === 'F') return plural ? 'joueuses' : 'joueuse';
  return plural ? 'joueurs' : 'joueur';
}

export function playerCount(gender: TeamGender, count: number): string {
  return `${count} ${playerNoun(gender, count)}`;
}

/** Adjectif accordé au genre de l'équipe : présente / présent, absente / absent… */
export function agree(gender: TeamGender, masculine: string, feminine: string, count = 1): string {
  const base = gender === 'F' ? feminine : masculine;
  return Math.abs(count) > 1 ? base + 's' : base;
}

/** Le genre d'un club pour un texte qui parle de toutes ses équipes (D-103) : F si toutes ses équipes
 *  sont féminines, M si toutes sont masculines, sinon mixte (masculin générique, D-008). */
export function clubGender(teams: readonly { gender: TeamGender }[]): TeamGender {
  if (teams.length && teams.every(t => t.gender === 'F')) return 'F';
  if (teams.length && teams.every(t => t.gender === 'M')) return 'M';
  return 'X';
}

export interface NamedPerson { first_name: string; nickname?: string | null }

/** Le surnom quand il existe (c'est ce qui distingue deux Emma), sinon le prénom. */
export function displayName(p: NamedPerson): string {
  const nick = (p.nickname ?? '').trim();
  return nick || p.first_name.trim();
}
